<span [ngClass]="[className$ | async, '-sh-full-width', 'digihaven-status-label']" [title]="value$ | async">{{ value$ | async }}</span>
